import { useContext } from "react";
import { Query } from "../../../shared/types";
import { StoreContext } from "../../context/store.context";

export function useQuery(): Query {
  const store = useContext(StoreContext);
  return store.query;
}
